import { Injectable, signal, computed } from '@angular/core';
import { Lang } from './lang.config';

import fr from './fr.json';
import en from './en.json';
import pl from './pl.json';
import ro from './ro.json';
import es from './es.json';
import pt from './pt.json';
import de from './de.json';
import it from './it.json';
import bg from './bg.json';
import lt from './lt.json';
import nl from './nl.json';
import cz from './cz.json';
import hu from './hu.json';
import tr from './tr.json';
import ru from './ru.json';

type Dict = Record<string, Record<string, string>>;

const DICTIONARIES: Record<Lang, Dict> = { fr, en, pl, ro, es, pt, de, it, bg, lt, nl, cz, hu, tr, ru };

@Injectable({ providedIn: 'root' })
export class I18nService {
  lang = signal<Lang>(this.getStoredLang());
  private dict = signal<Dict>(DICTIONARIES[this.lang()]);

  // Old API for header/queue/bcu/etc (returns flat record)
  t = computed(() => {
    const d = this.dict();
    const flat: Record<string, string> = {};
    for (const section of Object.values(d)) {
      for (const [k, v] of Object.entries(section)) {
        flat[k] = v;
      }
    }
    return flat;
  });

  // New API for registration (dot notation)
  tr(key: string): string {
    const parts = key.split('.');
    const section = this.dict()[parts[0]];
    if (!section) return key;
    return section[parts[1]] ?? key;
  }

  setLang(lang: Lang): void {
    this.lang.set(lang);
    this.dict.set(DICTIONARIES[lang]);
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem('tm-lang', lang);
    }
  }

  toggle(): void {
    this.setLang(this.lang() === 'fr' ? 'en' : 'fr');
  }

  private getStoredLang(): Lang {
    if (typeof localStorage === 'undefined') return 'fr';
    const stored = localStorage.getItem('tm-lang');
    if (stored && stored in DICTIONARIES) return stored as Lang;
    return 'fr';
  }
}
